import React from 'react'; // eslint-disable-line
import styled from 'styled-components';
import media from 'components/Media';

const ProductBrandName = styled.span.attrs({
  className: 'font-weight-light'
})`
  font-size: 1.6rem;
  color: ${(props) => props.theme.colors.grey};
  ${media.down.tablet`
    font-size: 1.4rem;
  `};
`;

export default ProductBrandName;
